import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

interface Props {
  variant?: "icon" | "full";
}

const ClearCacheButton = ({ variant = "icon" }: Props) => {
  const [clearing, setClearing] = useState(false);
  const queryClient = useQueryClient();

  const handleClear = async () => {
    setClearing(true);
    try {
      // Clear React Query cache
      queryClient.clear();

      // Clear localStorage caches (preserve auth)
      const keysToKeep = ["sb-hamhqxpknbxiuchdwxup-auth-token", "viamenu-theme"];
      const allKeys = Object.keys(localStorage);
      allKeys.forEach(key => {
        if (!keysToKeep.some(k => key.includes(k))) {
          localStorage.removeItem(key);
        }
      });

      // Unregister service workers
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(r => r.unregister()));
      }

      // Clear browser caches
      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.map(name => caches.delete(name)));
      }

      toast.success("Cache limpo com sucesso! Recarregando...");
      setTimeout(() => window.location.reload(), 800);
    } catch {
      toast.error("Erro ao limpar cache");
      setClearing(false);
    }
  };

  if (variant === "full") {
    return (
      <Button variant="outline" size="sm" onClick={handleClear} disabled={clearing} className="text-xs">
        <RefreshCw className={`h-3.5 w-3.5 mr-1.5 ${clearing ? "animate-spin" : ""}`} />
        Limpar Cache
      </Button>
    );
  }

  return (
    <button
      onClick={handleClear}
      disabled={clearing}
      title="Limpar cache e recarregar"
      className="p-2 rounded-lg hover:bg-secondary/60 text-muted-foreground transition-colors disabled:opacity-50"
    >
      <RefreshCw className={`h-4 w-4 ${clearing ? "animate-spin" : ""}`} />
    </button>
  );
};

export default ClearCacheButton;
